/* Ixaria – pagina cu toate recenziile (sections/ixaria-reviews.liquid, ixaria-reviews.css).

   Recenziile vin din Judge.me la fiecare vizita, de la aceeasi adresa publica pe care o
   foloseste pagina lor „toate recenziile" (widget_type=all-reviews-page; CORS deschis, cache de
   CDN de 20 de minute): HTML-ul recenziilor, cate 25 pe pagina, separat pentru recenziile
   produselor si pentru ale magazinului. Prima pagina a fiecaruia spune cate sunt in total, deci
   celelalte se cer deodata (~40 de cereri mici, ~300 KB cu gzip). Din HTML se scot datele (nota,
   autorul, data, titlul, textul, pozele, produsul) si se deseneaza cardurile de pe PDP
   (ixFillReviewRail din ixaria-pdp.js).

   Cu toate recenziile in pagina, subiectele (pastilele) si ordonarea lucreaza pe loc. Subiectul
   si ordonarea aleasa stau in adresa (?subiect=, ?ordine=), ca un link sa le pastreze. */
(function () {
  'use strict';

  var JM = 'https://cdn.judge.me/reviews/all_reviews_js_based?widget_type=all-reviews-page&platform=shopify';
  /* Pagini cerute deodata, cel mult (siguranta, daca Judge.me ar raporta un total gresit). */
  var MAX_PAGES = 120;
  var MONTHS = ['Ian.', 'Feb.', 'Mar.', 'Apr.', 'Mai', 'Iun.', 'Iul.', 'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];
  var STAR = '<svg class="star" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>';
  /* shield-check din Figma (38:665), 16px — ca pe PDP */
  var VERIFIED = '<span class="rv-ver"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M6 8L7.33333 9.33334L10 6.66667M8 14.6667C8 14.6667 13.3333 12 13.3333 8L13.3333 3.33333L8 1.33333L2.66667 3.33333L2.66667 8C2.66667 12 8 14.6667 8 14.6667Z" stroke="#363944" stroke-linecap="round" stroke-linejoin="round"/></svg>verificat</span>';
  var ARROW = '<svg viewBox="0 0 48 48" fill="none" aria-hidden="true"><circle cx="24" cy="24" r="24" fill="#fff"/><path d="M21 18L27 24L21 30" stroke="#1d1d1f" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  /* latimea pozei din card: 200px pe desktop, cat cardul pe telefon */
  var PHOTO_SIZES = '(min-aspect-ratio: 1/1) 200px, (min-width: 744px) 200px, calc(100vw - 40px)';
  /* desktop, ca pe PDP: ecran lat sau de la 744px */
  var DESK = window.matchMedia ? window.matchMedia('(min-aspect-ratio: 1/1), (min-width: 744px)') : { matches: true };
  var SORTS = {
    noi: function (a, b) { return b.time - a.time; },
    poze: function (a, b) { return (b.pics.length > 0) - (a.pics.length > 0) || b.time - a.time; },
    'nota-mare': function (a, b) { return b.rating - a.rating || b.time - a.time; },
    'nota-mica': function (a, b) { return a.rating - b.rating || b.time - a.time; }
  };

  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  /* fara majuscule si fara diacritice: „Livrarea" → „livrarea", „Mulțumim" → „multumim" */
  function norm(s) {
    s = String(s || '').toLowerCase();
    return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s;
  }
  function clean(s) {
    return String(s || '').replace(/\s+/g, ' ').trim();
  }
  function slug(s) {
    return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function fmtDate(t) {
    var d = new Date(t);
    return isNaN(d) ? '' : d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
  }
  /* „1 recenzie", „12 recenzii", „1.008 de recenzii" */
  function countText(n) {
    var s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    if (n === 1) return '1 recenzie';
    var tail = n % 100;
    return s + (tail === 0 || tail >= 20 ? ' de recenzii' : ' recenzii');
  }
  /* doar adrese https (Judge.me si CDN-ul Shopify); orice altceva se ignora */
  function https(u) {
    u = String(u || '').trim();
    if (/^\/\//.test(u)) u = 'https:' + u;
    return /^https:\/\/[^\s"'<>]+$/i.test(u) ? u : '';
  }
  /* Pozele Judge.me (review-images.judgeme.com) si ale Shopify se cer la latimea data. */
  function sized(u, w) {
    if (!/^https:\/\/(review-images\.judgeme\.com|cdn\.shopify\.com)\//i.test(u)) return u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, '$1' + w);
    return u + (u.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }
  function wait(ms) {
    return new Promise(function (res) { setTimeout(res, ms); });
  }

  /* ── Judge.me ─────────────────────────────────────────────────────── */
  /* O cerere care nu raspunde in PAGE_TIMEOUT se opreste si se reincearca (altfel lista ar
     astepta-o la nesfarsit). Prima pagina, necache-uita la Judge.me, vine in ~3s. */
  var PAGE_TIMEOUT = 10000;
  function getPage(shop, kind, page, tries, extra) {
    var url = JM + '&shop_domain=' + encodeURIComponent(shop) +
      '&review_type=' + (kind === 'shop' ? 'shop-reviews' : 'product-reviews') + '&page=' + page + (extra || '');
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, PAGE_TIMEOUT) : 0;
    return fetch(url, ctl ? { credentials: 'omit', signal: ctl.signal } : { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('Judge.me ' + r.status);
        return r.json();
      })
      .then(function (j) {
        clearTimeout(timer);
        return j;
      }, function (e) {
        clearTimeout(timer);
        throw e;
      })
      .catch(function (e) {
        if (tries > 0) return wait(800).then(function () { return getPage(shop, kind, page, tries - 1, extra); });
        throw e;
      });
  }
  /* Textul recenziei, cu randurile si paragrafele clientului (Judge.me le trimite ca <br> si <p>). */
  function bodyText(node) {
    if (!node) return '';
    Array.prototype.forEach.call(node.querySelectorAll('br'), function (br) {
      br.parentNode.replaceChild(node.ownerDocument.createTextNode('\n'), br);
    });
    var ps = node.querySelectorAll('p');
    var parts = ps.length ? Array.prototype.map.call(ps, function (p) { return p.textContent; }) : [node.textContent];
    return parts.map(function (s) {
      return s.split('\n').map(clean).filter(Boolean).join('\n');
    }).filter(Boolean).join('\n\n');
  }
  /* O pagina de recenzii Judge.me (HTML-ul widgetului) → datele fiecarei recenzii. */
  function parse(html, kind) {
    if (!html || typeof html !== 'string' || !window.DOMParser) return [];
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var out = [];
    Array.prototype.forEach.call(doc.querySelectorAll('.jdgm-rev[data-review-id]'), function (el) {
      var q = function (s) { return el.querySelector(s); };
      var sc = q('.jdgm-rev__rating');
      var ts = q('.jdgm-rev__timestamp');
      /* „2026-02-27 04:00:50 UTC" → „2026-02-27T04:00:50Z" */
      var when = ts ? Date.parse((ts.getAttribute('data-content') || '').replace(' UTC', 'Z').replace(' ', 'T')) : NaN;
      var pics = [];
      Array.prototype.forEach.call(el.querySelectorAll('.jdgm-rev__pics a.jdgm-rev__pic-link'), function (a) {
        /* dupa pozele clientului Judge.me pune si poza produsului; aceea nu e a recenziei */
        if (a.classList.contains('jdgm-rev__product-picture')) return;
        var big = https(a.getAttribute('href') || a.getAttribute('data-mfp-src'));
        var im = a.querySelector('img');
        var small = im ? https(im.getAttribute('data-src') || im.getAttribute('src')) : '';
        if (big) pics.push([big, small || big]);
      });
      var r = {
        id: el.getAttribute('data-review-id'),
        kind: kind,
        rating: Math.max(0, Math.min(5, Math.round(+(sc && sc.getAttribute('data-score')) || 0))),
        verified: el.getAttribute('data-verified-buyer') === 'true',
        time: isNaN(when) ? 0 : when,
        author: clean(q('.jdgm-rev__author') && q('.jdgm-rev__author').textContent),
        title: clean(q('.jdgm-rev__title') && q('.jdgm-rev__title').textContent),
        body: bodyText(q('.jdgm-rev__body')),
        pics: pics,
        product: '',
        productUrl: '',
        productImg: ''
      };
      /* Recenziile magazinului au ca „produs" magazinul insusi (link spre /): fara „Recenzie pentru". */
      if (kind !== 'shop') {
        var link = q('a.jdgm-rev__prod-link');
        var title = q('.jdgm-rev__prod-title');
        var pp = q('.jdgm-rev__product-picture');
        var href = link && link.getAttribute('href');
        r.product = clean((link || title) && (link || title).textContent);
        if (href && /^\/products\/[^\s?#"'<>]+$/.test(href)) r.productUrl = href;
        r.productImg = pp ? https(pp.getAttribute('href')) : '';
      }
      r.search = norm(r.title + ' \n ' + r.body);
      out.push(r);
    });
    return out;
  }
  /* Toate recenziile unui fel („product" / „shop"): prima pagina, apoi restul deodata. O pagina
     care nu vine nici dupa doua reincercari se sare (restul raman); daca nu vine prima, felul
     acela lipseste. onFirst primeste recenziile primei pagini cat restul inca se incarca. */
  function loadKind(shop, kind, onFirst) {
    return getPage(shop, kind, 1, 2).then(function (j) {
      var first = parse(j && j.html, kind);
      if (onFirst) onFirst(first);
      var per = first.length;
      if (!per) return first;
      var total = +(kind === 'shop' ? j.number_of_shop_reviews : j.number_of_product_reviews);
      if (!(total > 0)) return loadOneByOne(shop, kind, 2, first);
      var pages = Math.min(MAX_PAGES, Math.ceil(total / per));
      var rest = [];
      for (var p = 2; p <= pages; p++) {
        rest.push(getPage(shop, kind, p, 2).then(function (jj) { return parse(jj && jj.html, kind); }, function () { return []; }));
      }
      return Promise.all(rest).then(function (lists) {
        lists.unshift(first);
        return mendTies(shop, kind, lists, per, total);
      });
    });
  }
  /* Judge.me nu ordoneaza stabil recenziile cu aceeasi ora (importurile au adesea secunda
     identica): cand un astfel de grup cade pe granita dintre doua pagini, o recenzie apare pe
     amandoua, iar alta pe niciuna. Dublurile se sar; cele lipsa se cauta in aceleasi locuri din
     lista in ordine crescatoare (cate doua pagini pe granita, cel mult 4 granite). */
  function mendTies(shop, kind, lists, per, total) {
    var seen = {}, out = [], edges = [];
    lists.forEach(function (l, k) {
      l.forEach(function (r) {
        if (seen[r.id]) return;
        seen[r.id] = true;
        out.push(r);
      });
      var next = lists[k + 1];
      if (l.length && next && next.length && l[l.length - 1].time === next[0].time) edges.push(k + 1);
    });
    if (out.length >= total || !edges.length) return out;
    var want = {};
    edges.slice(0, 4).forEach(function (p) {
      /* granita de dupa pagina p, numarata de la capatul celalalt al listei */
      var c = total - p * per;
      [c - 2, c + 2].forEach(function (i) {
        var pg = Math.floor(Math.max(0, Math.min(total - 1, i)) / per) + 1;
        want[pg] = true;
      });
    });
    return Promise.all(Object.keys(want).map(function (pg) {
      return getPage(shop, kind, +pg, 1, '&sort_by=created_at&sort_dir=asc')
        .then(function (j) { return parse(j && j.html, kind); }, function () { return []; });
    })).then(function (more) {
      more.forEach(function (l) {
        l.forEach(function (r) {
          if (seen[r.id]) return;
          seen[r.id] = true;
          out.push(r);
        });
      });
      return out;
    });
  }
  /* Fara total in raspuns: pagina dupa pagina, pana la una goala. */
  function loadOneByOne(shop, kind, page, acc) {
    if (page > MAX_PAGES) return Promise.resolve(acc);
    return getPage(shop, kind, page, 2).then(function (j) {
      var list = parse(j && j.html, kind);
      return list.length ? loadOneByOne(shop, kind, page + 1, acc.concat(list)) : acc;
    }, function () { return acc; });
  }

  /* ── Subiectele ───────────────────────────────────────────────────── */
  /* „livr, la timp, pret." → un singur RegExp: fiecare cuvant la inceput de cuvant, „la timp"
     cu orice spatiu intre cuvinte, „pret." doar cuvantul intreg. */
  function topicRx(keys) {
    var parts = String(keys || '').split(/[,;\n]+/).map(function (k) {
      k = norm(k).trim();
      var exact = /\.$/.test(k);
      k = k.replace(/\.+$/, '').trim();
      if (!k) return '';
      var src = k.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+');
      return exact ? src + '(?![a-z0-9])' : src;
    }).filter(Boolean);
    return parts.length ? new RegExp('(?:^|[^a-z0-9])(?:' + parts.join('|') + ')') : null;
  }

  /* ── Cardul (ixFillReviewRail si ixReviewPhotoHtml din ixaria-pdp.js) ─ */
  function photoImg(src, alt, extra) {
    var set = [400, 640, 1024].map(function (w) { return esc(sized(src, w)) + ' ' + w + 'w'; }).join(', ');
    return '<img src="' + esc(sized(src, 640)) + '" srcset="' + set + '" sizes="' + PHOTO_SIZES + '" alt="' + esc(alt) + '" loading="lazy"' + (extra || '') + '>';
  }
  function photoHtml(pics, alt) {
    if (pics.length < 2) return photoImg(pics[0][0], alt);
    return '<div class="rp-trk">' +
        pics.map(function (p) { return photoImg(p[0], alt, ' draggable="false"'); }).join('') +
      '</div>' +
      '<button type="button" class="rp-nav rp-prev" aria-label="Poza anterioară">' + ARROW + '</button>' +
      '<button type="button" class="rp-nav rp-next" aria-label="Poza următoare">' + ARROW + '</button>' +
      '<div class="rp-dots" aria-hidden="true">' +
        pics.map(function (p, i) { return '<span' + (i ? '' : ' class="on"') + '></span>'; }).join('') +
      '</div>';
  }
  function cardHtml(r, i) {
    var stars = new Array(r.rating + 1).join(STAR);
    var alt = r.title || r.product || 'Poza clientului';
    var n = r.pics.length;
    return '<article class="rvcard' + (n ? '' : ' no-pic') + '" data-i="' + i + '">' +
      (n
        ? '<div class="rp' + (n > 1 ? ' rp-multi' : '') + '">' +
            photoHtml(r.pics, alt) +
            '<div class="rv-badge"><div class="stars">' + stars + '</div>' + r.rating + '/5</div>' +
          '</div>'
        : '') +
      '<div class="bd">' +
        '<div class="rv-meta">' +
          /* stelele de langa nume se vad pe desktop (si pe telefon la cardurile fara poza) */
          '<span class="rv-stars" role="img" aria-label="' + r.rating + ' din 5 stele">' + stars + '<span class="rv-score">' + r.rating + '/5</span></span>' +
          '<span class="rv-name">' + esc(r.author || 'Anonim') + '</span>' +
          (r.verified ? VERIFIED : '') +
          (r.time ? '<span class="rv-date">' + esc(fmtDate(r.time)) + '</span>' : '') +
        '</div>' +
        '<div class="rv-body">' +
          (r.title ? '<div class="rv-ttl">' + esc(r.title) + '</div>' : '') +
          (r.body ? '<div class="rv-txt">' + esc(r.body) + '</div>' : '') +
        '</div>' +
        (r.product
          ? '<div class="rv-prod">' +
              (r.productImg ? '<img src="' + esc(sized(r.productImg, 200)) + '" alt="" loading="lazy">' : '') +
              '<div><div class="a">Recenzie pentru</div>' +
                (r.productUrl
                  ? '<a class="b" href="' + esc(r.productUrl) + '">' + esc(r.product) + '</a>'
                  : '<div class="b">' + esc(r.product) + '</div>') +
              '</div>' +
            '</div>'
          : '') +
      '</div>' +
    '</article>';
  }
  /* Poza din banda cardului care se vede acum (ixRpIndex). */
  function rpIndex(rp) {
    var trk = rp && rp.querySelector('.rp-trk');
    if (!trk || !trk.clientWidth) return 0;
    return Math.max(0, Math.min(trk.children.length - 1, Math.round(trk.scrollLeft / trk.clientWidth)));
  }
  /* Sagetile: o poza inainte sau inapoi, in cerc (ixRpStep). */
  function rpStep(rp, d) {
    var trk = rp && rp.querySelector('.rp-trk');
    if (!trk) return;
    var n = trk.children.length;
    trk.scrollTo({ left: ((rpIndex(rp) + d) % n + n) % n * trk.clientWidth, behavior: 'smooth' });
  }

  /* ── Gesturile galeriei (bindSwipe / bindWheelStep din ixaria-classic-pdp.liquid) ── */
  function bindSwipe(el, onSwipe, follow) {
    var sx = 0, sy = 0, dx = 0, dy = 0, active = false, axis = '';
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.button) return;
      if (e.target.closest && e.target.closest('button, a')) return;
      sx = e.clientX; sy = e.clientY; dx = 0; dy = 0; axis = ''; active = true;
      if (el.setPointerCapture && e.pointerId != null) {
        try { el.setPointerCapture(e.pointerId); } catch (err) {}
      }
    });
    el.addEventListener('pointermove', function (e) {
      if (!active) return;
      dx = e.clientX - sx;
      dy = e.clientY - sy;
      if (!axis) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (axis === 'y') { active = false; follow(null); return; }
      }
      follow(dx);
    });
    el.addEventListener('pointerup', function () {
      if (!active) return;
      active = false;
      follow(null);
      if (Math.abs(dx) > 40) onSwipe(dx < 0 ? 1 : -1);
    });
    el.addEventListener('pointercancel', function () {
      active = false;
      follow(null);
    });
  }
  /* Rotita si trackpadul schimba poza (pagina de sub galerie nu se deruleaza). */
  function bindWheelStep(el, onStep) {
    var acc = 0, lock = false;
    el.addEventListener('wheel', function (e) {
      var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
      e.preventDefault();
      if (lock) return;
      acc += d;
      if (Math.abs(acc) < 50) return;
      onStep(acc < 0 ? -1 : 1);
      acc = 0;
      lock = true;
      setTimeout(function () { lock = false; }, 320);
    }, { passive: false });
  }

  /* ── Galeria pe tot ecranul (#rvgal, ca pe pagina produselor neconfigurabile) ──
     Pozele stau pe o banda care urmeaza degetul la tras si se invarte in cerc: dupa ultima,
     „inainte" aduce prima. pos e pozitia benzii (poate iesi din [0, n) cat trece peste capat),
     idx indicele real. Continutul unui slide se pune doar cand el sau un vecin e cel vizibil. */
  function Gallery(el, owner) {
    var self = this;
    this.el = el;
    this.trk = el.querySelector('[data-ixr-trk]');
    this.thumbs = el.querySelector('[data-ixr-thumbs]');
    this.stage = el.querySelector('[data-ixr-stage]');
    this.close_ = el.querySelector('[data-ixr-close]');
    this.items = [];
    this.idx = -1;
    this.pos = 0;
    this.timer = null;
    this.back = null;
    /* la capatul paginii, ca sa nu-l taie nimic si sa stea peste antet */
    el.ixOwner = owner;
    document.body.appendChild(el);
    el.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-ixr-close], [data-ixr-step]');
      if (!b) return;
      if (b.hasAttribute('data-ixr-close')) self.close();
      else self.step(+b.getAttribute('data-ixr-step') || 1);
    });
    document.addEventListener('keydown', function (e) {
      if (!self.isOpen()) return;
      if (e.key === 'Escape') self.close();
      else if (e.key === 'ArrowLeft') self.step(-1);
      else if (e.key === 'ArrowRight') self.step(1);
    });
    window.addEventListener('resize', function () { if (self.isOpen()) self.navFit(); });
    bindSwipe(this.stage, function (d) { self.step(d); }, function (dx) { self.follow(dx); });
    bindWheelStep(this.stage, function (d) { self.step(d); });
  }
  Gallery.prototype.isOpen = function () {
    return this.el.classList.contains('on');
  };
  Gallery.prototype.mod = function (p) {
    var n = this.items.length || 1;
    return ((p % n) + n) % n;
  };
  Gallery.prototype.fill = function (i) {
    var n = this.items.length;
    if (!n) return;
    var sl = this.trk.children[this.mod(i)];
    if (!sl || sl.firstChild) return;
    var self = this, p = this.items[this.mod(i)];
    var img = document.createElement('img');
    img.addEventListener('load', function () { if (sl.classList.contains('on')) self.navFit(); });
    /* poza la care te uiti vine inaintea miniaturilor si a vecinelor */
    if ('fetchPriority' in img) img.fetchPriority = this.mod(i) === this.idx ? 'high' : 'auto';
    img.src = p.src;
    img.alt = p.alt || '';
    img.draggable = false;
    sl.appendChild(img);
  };
  /* Sagetile stau langa poza: cand ea e mai ingusta decat ecranul, golul de pe fiecare parte
     ajunge in --rvg-gap. */
  Gallery.prototype.navFit = function () {
    var sl = this.trk.querySelector('.rvg-sl.on');
    var m = sl && sl.querySelector('img');
    if (!m || !(m.complete && m.naturalWidth > 0) || !m.offsetWidth) return;
    this.stage.style.setProperty('--rvg-gap', Math.max(0, (sl.clientWidth - m.offsetWidth) / 2) + 'px');
  };
  Gallery.prototype.lay = function (lo) {
    var n = this.items.length;
    Array.prototype.forEach.call(this.trk.children, function (sl, i) {
      var k = Math.ceil((lo - i) / n);
      sl.style.transform = k ? 'translateX(' + k * n * 100 + '%)' : '';
    });
  };
  Gallery.prototype.visualPos = function () {
    var w = this.trk.offsetWidth;
    var m = w && /matrix\(([^)]+)\)/.exec(getComputedStyle(this.trk).transform);
    if (!m) return this.pos;
    return -parseFloat(m[1].split(',')[4]) / w;
  };
  Gallery.prototype.place = function () {
    this.trk.style.transform = 'translateX(' + (-this.pos * 100) + '%)';
  };
  Gallery.prototype.snap = function () {
    this.trk.style.transition = 'none';
    this.place();
    void this.trk.offsetWidth;
    this.trk.style.transition = '';
  };
  Gallery.prototype.rest = function () {
    this.lay(0);
    if (this.pos === this.idx) return;
    this.pos = this.idx;
    this.snap();
  };
  Gallery.prototype.render = function () {
    var self = this;
    /* poza vizibila si cate doua de fiecare parte, ca la tras sa fie deja gata */
    this.fill(this.idx);
    this.fill(this.idx + 1); this.fill(this.idx - 1);
    this.fill(this.idx + 2); this.fill(this.idx - 2);
    Array.prototype.forEach.call(this.trk.children, function (sl, k) {
      var on = k === self.idx;
      sl.classList.toggle('on', on);
      sl.setAttribute('aria-hidden', on ? 'false' : 'true');
    });
    this.navFit();
    var thumbs = this.thumbs.children;
    Array.prototype.forEach.call(thumbs, function (th, k) {
      var on = k === self.idx;
      th.classList.toggle('on', on);
      if (on) th.setAttribute('aria-current', 'true'); else th.removeAttribute('aria-current');
    });
    var cur = thumbs[this.idx];
    if (cur && this.thumbs.scrollTo) {
      this.thumbs.scrollTo({ left: cur.offsetLeft - (this.thumbs.clientWidth - cur.offsetWidth) / 2, behavior: 'smooth' });
    }
  };
  /* Salt direct (la deschidere, din miniaturi), fara alunecare peste slide-uri goale; doar
     vecina celei active aluneca, ca un pas. */
  Gallery.prototype.show = function (i) {
    if (!this.items.length) return;
    i = this.mod(i);
    if (this.idx >= 0 && Math.abs(i - this.idx) === 1) return this.step(i - this.idx);
    clearTimeout(this.timer);
    this.idx = this.pos = i;
    this.lay(0);
    this.snap();
    this.render();
  };
  Gallery.prototype.step = function (d) {
    if (this.items.length < 2) return;
    var self = this;
    this.pos += d;
    this.idx = this.mod(this.pos);
    /* fereastra acopera si locul de unde pleaca banda, ca poza sa nu sara */
    this.lay(Math.floor(Math.min(this.visualPos(), this.pos)));
    clearTimeout(this.timer);
    this.timer = setTimeout(function () { self.rest(); }, 400);   /* tranzitia e de 0.35s */
    this.place();
    this.render();
  };
  /* Cat tine gestul, banda sta lipita de deget; o singura poza se misca doar o treime. */
  Gallery.prototype.follow = function (dx) {
    var self = this;
    clearTimeout(this.timer);
    if (dx === null) {
      this.trk.style.transition = '';
      this.place();
      this.timer = setTimeout(function () { self.rest(); }, 400);
      return;
    }
    if (this.items.length > 1) this.lay(dx < 0 ? this.pos : this.pos - 1);
    else dx = dx / 3;
    this.trk.style.transition = 'none';
    this.trk.style.transform = 'translateX(calc(' + (-this.pos * 100) + '% + ' + Math.round(dx) + 'px))';
  };
  Gallery.prototype.open = function (items, start) {
    var self = this;
    this.items = items || [];
    if (!this.items.length) return;
    this.back = document.activeElement;
    this.stage.style.removeProperty('--rvg-gap');
    this.trk.innerHTML = '';
    this.thumbs.innerHTML = '';
    this.items.forEach(function (p, i) {
      /* no-empty: tema ascunde orice div gol (theme.css, div:empty). Un slide inca fara poza
         disparea din banda, iar saltul din miniaturi peste slide-uri goale ajungea langa poza
         aleasa, nu pe ea (cu sagetile mergea: vecinele sunt deja umplute). */
      var sl = document.createElement('div');
      sl.className = 'rvg-sl no-empty';
      self.trk.appendChild(sl);
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rvg-thumb';
      b.setAttribute('aria-label', 'Poza ' + (i + 1) + ' din ' + self.items.length);
      /* Toate miniaturile se cer de la deschidere, nu „lazy": banda arata din prima toate pozele
         recenziilor (sunt mici, 160px). Prioritate mica, ca poza mare sa vina prima. */
      var ti = document.createElement('img');
      ti.alt = '';
      ti.decoding = 'async';
      if ('fetchPriority' in ti) ti.fetchPriority = 'low';
      ti.src = p.thumb || p.src;
      b.appendChild(ti);
      b.onclick = function () { self.show(i); };
      self.thumbs.appendChild(b);
    });
    var single = this.items.length < 2;
    Array.prototype.forEach.call(this.el.querySelectorAll('.rvg-nav'), function (n) { n.hidden = single; });
    this.el.classList.add('on');
    this.el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    this.idx = -1;
    this.show(start || 0);
    if (this.close_) this.close_.focus({ preventScroll: true });
  };
  Gallery.prototype.close = function () {
    if (!this.isOpen()) return;
    this.el.classList.remove('on');
    this.el.setAttribute('aria-hidden', 'true');
    this.trk.innerHTML = '';
    this.thumbs.innerHTML = '';
    document.body.style.overflow = '';
    if (this.back && this.back.focus && this.back.isConnected) this.back.focus({ preventScroll: true });
    this.back = null;
  };

  /* ── Pagina ───────────────────────────────────────────────────────── */
  function Reviews(root) {
    var self = this;
    this.root = root;
    this.shop = root.getAttribute('data-shop') || (window.Shopify && window.Shopify.shop) || '';
    this.first = +root.getAttribute('data-first') || 10;
    this.step = +root.getAttribute('data-step') || 10;
    this.list = root.querySelector('[data-ixr-list]');
    this.more = root.querySelector('[data-ixr-more]');
    this.empty = root.querySelector('[data-ixr-empty]');
    this.error = root.querySelector('[data-ixr-error]');
    this.status = root.querySelector('[data-ixr-status]');
    this.count = root.querySelector('[data-ixr-count]');
    this.sortSel = root.querySelector('[data-ixr-sort]');
    this.sortLabel = root.querySelector('[data-ixr-sort-label]');
    this.pills = Array.prototype.slice.call(root.querySelectorAll('[data-ixr-topic]'));
    this.pillsBox = root.querySelector('[data-ixr-pills]');
    this.morep = root.querySelector('[data-ixr-morep]');
    this.visible = +root.getAttribute('data-visible') || 6;
    this.skeleton = this.list ? this.list.innerHTML : '';
    this.all = [];
    this.view = [];
    this.shown = 0;
    this.loaded = false;

    var cfg = [];
    var tj = root.querySelector('[data-ixr-topics]');
    try { cfg = JSON.parse(tj ? tj.textContent : '[]') || []; } catch (e) { cfg = []; }
    this.topics = {};
    cfg.forEach(function (t) {
      var rx = topicRx(t.keys);
      if (rx) self.topics[t.id] = { label: t.label, rx: rx };
    });
    this.pills.forEach(function (b) {
      var id = b.getAttribute('data-ixr-topic');
      if (id === 'poze') self.topics.poze = { label: b.textContent.trim(), photos: true };
      if (self.topics[id]) self.topics[id].slug = slug(self.topics[id].label);
    });

    /* subiectul si ordonarea din adresa */
    this.topic = '';
    this.sort = 'noi';
    var qs = new URLSearchParams(location.search);
    var want = qs.get('subiect');
    if (want) {
      Object.keys(this.topics).forEach(function (id) {
        if (self.topics[id].slug === want) self.topic = id;
      });
    }
    if (SORTS[qs.get('ordine')]) this.sort = qs.get('ordine');
    if (this.sortSel) this.sortSel.value = this.sort;
    this.syncControls();

    var galEl = root.querySelector('[data-ixr-gal]');
    this.gallery = galEl ? new Gallery(galEl, root) : null;
    this.bind();
    this.fitPills();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { self.fitPills(); });
    var raf = 0;
    window.addEventListener('resize', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; self.fitPills(); });
    });
    this.load();
  }

  Reviews.prototype.bind = function () {
    var self = this, root = this.root;
    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t.closest) return;
      var nav = t.closest('.rp-nav');
      if (nav) return rpStep(nav.parentNode, nav.classList.contains('rp-next') ? 1 : -1);
      var rp = t.closest('.rvcard:not(.is-skel) .rp');
      if (rp) return self.openPhotos(rp);
      var pill = t.closest('[data-ixr-topic]');
      if (pill) {
        var id = pill.getAttribute('data-ixr-topic');
        return self.setTopic(self.topic === id ? '' : id);
      }
      var morep = t.closest('[data-ixr-morep]');
      if (morep) return self.toggleMorePills();
      if (t.closest('[data-ixr-more]')) return self.showMore();
      if (t.closest('[data-ixr-all]')) return self.setTopic('');
      if (t.closest('[data-ixr-retry]')) return self.load();
    });
    if (this.sortSel) {
      this.sortSel.addEventListener('change', function () {
        self.sort = SORTS[self.sortSel.value] ? self.sortSel.value : 'noi';
        self.syncControls();
        self.writeUrl();
        if (self.loaded) self.apply();
      });
    }
    /* Punctele urmeaza banda de poze a cardului. „scroll" nu urca prin pagina: captura. */
    root.addEventListener('scroll', function (e) {
      var trk = e.target;
      if (!trk.classList || !trk.classList.contains('rp-trk')) return;
      var rp = trk.parentNode, k = rpIndex(rp);
      Array.prototype.forEach.call(rp.querySelectorAll('.rp-dots span'), function (d, i) { d.classList.toggle('on', i === k); });
    }, true);
  };

  Reviews.prototype.load = function () {
    var self = this;
    if (!this.list) return;
    this.loaded = false;
    this.error.hidden = true;
    this.empty.hidden = true;
    this.more.hidden = true;
    this.list.hidden = false;
    this.list.innerHTML = this.skeleton;
    this.list.setAttribute('aria-busy', 'true');
    if (!this.shop || !window.fetch || !window.Promise) return this.fail();
    var merge = function (lists) {
      var seen = {}, all = [];
      lists.forEach(function (l) {
        (l || []).forEach(function (r) {
          if (seen[r.id]) return;
          seen[r.id] = true;
          all.push(r);
        });
      });
      return all;
    };
    /* Cele mai noi recenzii sunt pe prima pagina a fiecarui fel: cu amandoua venite, lista
       se arata deja (corect pentru „Cele mai noi"), iar restul paginilor vin in spate. Inainte,
       lista astepta toate cele ~40 de pagini (5s si peste, cu Judge.me necache-uit). */
    var firsts = [], waiting = 2, finished = false;
    var firstIn = function (l) {
      firsts.push(l || []);
      if (--waiting || finished) return;
      var all = merge(firsts);
      if (!all.length) return;
      self.all = all;
      self.partial = true;
      self.loaded = true;
      self.apply();
    };
    var one = function (kind) {
      var got = false;
      return loadKind(self.shop, kind, function (l) { got = true; firstIn(l); })
        .then(function (v) { return v; }, function () { return null; })
        .then(function (v) {
          if (!got) firstIn([]);
          return v;
        });
    };
    Promise.all([one('product'), one('shop')]).then(function (res) {
      finished = true;
      var keep = self.partial;
      self.partial = false;
      if (!res[0] && !res[1]) {
        if (!keep) self.fail();
        return;
      }
      self.all = merge(res);
      self.loaded = true;
      self.markPills();
      self.apply(keep);
    });
  };
  Reviews.prototype.fail = function () {
    this.list.innerHTML = '';
    this.list.hidden = true;
    this.list.setAttribute('aria-busy', 'false');
    this.error.hidden = false;
    this.status.textContent = 'Recenziile nu s-au putut încărca.';
  };
  Reviews.prototype.matches = function (r, id) {
    var t = id && this.topics[id];
    if (!t) return true;
    return t.photos ? r.pics.length > 0 : t.rx.test(r.search);
  };
  /* Subiectele fara nicio recenzie se sting (ca optiunile fara produse din PLP). */
  Reviews.prototype.markPills = function () {
    var self = this;
    this.pills.forEach(function (b) {
      var id = b.getAttribute('data-ixr-topic');
      var any = self.all.some(function (r) { return self.matches(r, id); });
      b.classList.toggle('is-none', !any);
    });
  };
  Reviews.prototype.syncControls = function () {
    var self = this;
    this.pills.forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-ixr-topic') === self.topic ? 'true' : 'false');
    });
    /* subiectul ales din „Mai multe" ramane la vedere */
    var chosen = this.topic && this.root.querySelector('[data-ixr-topic="' + this.topic + '"][data-ixr-extra]');
    if (chosen) this.toggleMorePills(true);
    if (this.sortLabel && this.sortSel) {
      var o = this.sortSel.options[this.sortSel.selectedIndex];
      this.sortLabel.textContent = o ? o.text : '';
    }
  };
  /* Pe desktop pastilele stau pe un singur rand: cele peste `visible` si cele care nu mai incap
     trec in „Mai multe". Se masoara cu toate la vedere (.is-fit) si cu „Mai multe" pe rand. */
  Reviews.prototype.fitPills = function () {
    var btn = this.morep, box = this.pillsBox, self = this;
    if (!btn || !box || !this.pills.length) return;
    var desk = DESK.matches;
    /* deschise, pastilele stau direct in bara (display: contents): se masoara inchise */
    var open = this.root.classList.contains('is-more');
    this.root.classList.remove('is-more');
    btn.hidden = false;
    this.root.classList.add('is-fit');
    var avail = box.clientWidth;
    var gap = parseFloat(getComputedStyle(box).columnGap) || 0;
    var x = 0, extra = 0;
    this.pills.forEach(function (b, i) {
      x += (i ? gap : 0) + b.offsetWidth;
      if (desk && (i >= self.visible || x > avail + 0.5)) {
        b.setAttribute('data-ixr-extra', '');
        extra++;
      } else {
        b.removeAttribute('data-ixr-extra');
      }
    });
    this.root.classList.remove('is-fit');
    if (open) this.root.classList.add('is-more');
    btn.hidden = !extra;
    if (!extra) this.toggleMorePills(false);
    else if (this.topic && this.root.querySelector('[data-ixr-topic="' + this.topic + '"][data-ixr-extra]')) this.toggleMorePills(true);
  };
  Reviews.prototype.toggleMorePills = function (open) {
    var btn = this.morep;
    if (!btn) return;
    var on = typeof open === 'boolean' ? open : !this.root.classList.contains('is-more');
    this.root.classList.toggle('is-more', on);
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    var l = btn.querySelector('[data-ixr-morep-l]');
    if (l) l.textContent = on ? 'Mai puține' : 'Mai multe';
  };
  Reviews.prototype.setTopic = function (id) {
    this.topic = id && this.topics[id] ? id : '';
    this.syncControls();
    this.writeUrl();
    if (this.loaded) this.apply();
  };
  Reviews.prototype.writeUrl = function () {
    if (!window.history || !history.replaceState || !window.URL) return;
    var u = new URL(location.href);
    var t = this.topic && this.topics[this.topic];
    if (t) u.searchParams.set('subiect', t.slug); else u.searchParams.delete('subiect');
    if (this.sort !== 'noi') u.searchParams.set('ordine', this.sort); else u.searchParams.delete('ordine');
    history.replaceState(history.state, '', u.toString());
  };
  /* Lista dupa subiect si ordonare; incepe din nou cu primele `first`. keep: cate se vedeau
     raman la vedere (lista completa venita peste prima pagina, load). Cat lista e partiala
     (this.partial), numarul de recenzii ramane cel din pagina (totalul din Judge.me). */
  Reviews.prototype.apply = function (keep) {
    var self = this;
    var list = this.all.filter(function (r) { return self.matches(r, self.topic); });
    var by = SORTS[this.sort] || SORTS.noi;
    list.sort(function (a, b) { return by(a, b) || (a.id < b.id ? -1 : a.id > b.id ? 1 : 0); });
    this.view = list;
    /* subiect fara recenzii pe primele pagini: inca se cauta in rest, nu „Nicio recenzie" */
    if (this.partial && !list.length) {
      this.shown = 0;
      this.list.innerHTML = this.skeleton;
      this.list.hidden = false;
      this.empty.hidden = true;
      this.more.hidden = true;
      return;
    }
    this.shown = Math.min(list.length, keep ? Math.max(this.first, this.shown || 0) : this.first);
    this.list.innerHTML = list.slice(0, this.shown).map(cardHtml).join('');
    this.list.hidden = !list.length;
    this.list.setAttribute('aria-busy', 'false');
    this.empty.hidden = list.length > 0;
    var allBtn = this.empty.querySelector('[data-ixr-all]');
    if (allBtn) allBtn.hidden = !this.topic;
    this.more.hidden = this.shown >= list.length;
    if (this.partial) return;
    var t = this.topic && this.topics[this.topic];
    if (this.count) this.count.textContent = countText(list.length);
    this.status.textContent = list.length
      ? countText(list.length) + (t ? (t.photos ? ' cu poze' : ' despre ' + t.label) : '')
      : 'Nicio recenzie' + (t ? (t.photos ? ' cu poze' : ' despre ' + t.label) : '');
  };
  /* „Încarcă mai multe": urmatoarele `step` recenzii, puse dupa cele de acum. Focusul trece
     pe prima noua, ca de la tastatura sa se continue de acolo. */
  Reviews.prototype.showMore = function () {
    var from = this.shown;
    this.shown = Math.min(this.view.length, this.shown + this.step);
    if (this.shown <= from) return;
    this.list.insertAdjacentHTML('beforeend', this.view.slice(from, this.shown).map(function (r, k) {
      return cardHtml(r, from + k);
    }).join(''));
    this.more.hidden = this.shown >= this.view.length;
    var firstNew = this.list.querySelector('.rvcard[data-i="' + from + '"]');
    if (firstNew) {
      firstNew.setAttribute('tabindex', '-1');
      firstNew.focus({ preventScroll: true });
    }
  };
  /* Galeria: pozele tuturor recenziilor din lista (si ale celor inca neafisate), in ordinea ei,
     deschisa pe poza din card care se vede acum. */
  Reviews.prototype.openPhotos = function (rp) {
    if (!this.gallery) return;
    var card = rp.closest('.rvcard');
    var ci = card ? +card.getAttribute('data-i') : -1;
    var items = [], start = 0;
    this.view.forEach(function (r, i) {
      if (i === ci) start = items.length + rpIndex(rp);
      r.pics.forEach(function (p) {
        items.push({ src: p[0], thumb: p[1], alt: r.title || r.product || 'Poza clientului' });
      });
    });
    this.gallery.open(items, start);
  };

  function init() {
    /* galeriile sectiunilor scoase (editorul de teme reincarca sectiunea) */
    Array.prototype.forEach.call(document.querySelectorAll('body > [data-ixr-gal]'), function (g) {
      if (g.ixOwner && !g.ixOwner.isConnected) g.remove();
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-ixr]'), function (root) {
      if (root.ixReviews) return;
      root.ixReviews = new Reviews(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  /* editorul de teme reincarca sectiunea */
  document.addEventListener('shopify:section:load', init);
})();
